import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MovieCard from "../components/MovieCard";
import { getListDetail } from "../api/list.api";

const PYRAMID_ROWS = [4, 3, 2, 1];

const MovieList = () => {
  const { listId } = useParams();
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMovie, setSelectedMovie] = useState(null);

  useEffect(() => {
    const fetchListData = async () => {
      try {
        setIsLoading(true);
        const data = await getListDetail(listId);
        setListData(data);
      } catch (error) {
        console.error("Error fetching list movies data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchListData();
  }, [listId]);

  let offset = 0;
  const movies = listData?.moviesList ?? [];

  return (
    <div className="movie-list">
      <div className={`movie-list-content ${isLoading ? "hide" : "show"}`}>
        <div className="movie-list-container">
          <h1 className="movie-list-title">{listData?.title}</h1>
          <h2 className="movie-list-desc">{listData?.description}</h2>

          <div className="movie-pyramid">
            {PYRAMID_ROWS.map((count, rowIndex) => {
              const rowItems = movies.slice(offset, offset + count);
              offset += count;

              return (
                <div key={rowIndex} className={`pyramid-row row-${count}`}>
                  {rowItems?.map((item, index) => (
                    <div key={index} className="movie-card-list-wrapper">
                      <div key={index} className="movie-card-list-wrapper pyramid-item">
                        <MovieCard
                          id={item.mid}
                          poster={item.poster}
                          onClick={() => setSelectedMovie(item)}
                        />
                        <h3 className="movie-rank">{item.rank}</h3>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}

            {selectedMovie && (
              <div className="movie-overlay" onClick={() => setSelectedMovie(null)}>
                <div
                  className="movie-zoom-wrapper"
                  onClick={(e) => e.stopPropagation()}
                >
                  <MovieCard
                    id={selectedMovie.mid}
                    poster={selectedMovie.poster}
                  />

                  <div className="movie-zoom-description-wrapper">
                    <h2 className="movie-zoom-description-title">{selectedMovie.title}</h2>
                    <p className="movie-zoom-description">{selectedMovie.description}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MovieList;
